<template>
  <div>
    <el-dialog
      title="订单跟进"
      :visible.sync="showEdit"
      @close="remarkClose"
      width="60%"
      class="abnormal complaint remark_modal"
      :append-to-body="true"
      id="orderlist"
    >
      <div class="remark-add">
        <order-row ref="orderRow" :info="remarkInfo"></order-row>
        <div class="gengjiun">
          <div class="modal-tit">跟进内容</div>
          <el-input
            type="textarea"
            placeholder="请描述"
            v-model="remark"
            maxlength="500"
            show-word-limit
          >
          </el-input>
          <div class="complaint-img eva-upload-imgs genjinupload">
            <a-upload
              accept="image/*"
              :action="baseApl + '/common/common/upload_file'"
              listType="picture-card"
              :fileList="followUpList"
              @change="followUpChange"
              @preview="handlePreview"
              :data="webToken"
              :headers="webToken"
            >
              <div v-if="followUpList.length < 8">
                <a-icon type="plus" />
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="remarkClose">取 消</el-button>
        <el-button type="primary" @click="setRemark" :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
import orderRow from "@/components/order/orderRow";

export default {
  components: {
    orderRow,
  },
  data() {
    return {
      remark: "",
      showEdit: false,
      previewVisible: false,
      previewImage: "",
      followUpList: [],
      remarkInfo: {},
      baseApl: process.env.VUE_APP_BASE_API,
      loading: false,
      webToken: {
        WEB_TOKEN: Cookies.get("token"),
      },
      followUpInfo: {},
    };
  },

  methods: {
    add(item) {
      this.remarkInfo = item;
      this.showEdit = true;
    },
    edit(orderinfo, item) {
      this.remarkInfo = orderinfo;
      console.log(orderinfo);
      console.log(item);
      this.followUpInfo = item;
      this.showEdit = true;
      this.remark = item.content;
      if (item.imgList) {
        this.followUpList = item.imgList.split(",").map((i, index) => {
          return {
            uid: index + 1,
            status: "done",
            url: i,
            name: "跟进图片.png",
          };
        });
      }
    },
    // 备注弹窗关闭
    remarkClose() {
      this.remarkInfo = {};
      this.showEdit = false;
      this.remark = "";
      this.followUpList = [];
    },
    // 订单跟进拍照
    followUpChange({ fileList }) {
      this.followUpList = fileList;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    // 保存备注
    setRemark() {
      this.$message.closeAll();
      let imgList = this.followUpList.map((i) => i.url || i.response.data.url);
      if (!this.remark)
        return this.$message({
          message: "请输入跟进内容",
          type: "error",
        });
      this.loading = true;
      let url = "";
      let params = {
        orderId: this.remarkInfo.id,
        imgList: imgList.join(","),
        content: this.remark,
      };
      // 编辑
      if (this.followUpInfo.id) {
        url = "/order/api/order/edit_order_follow";
        params.id = this.followUpInfo.id;
      } else {
        url = "/order/api/order/add_follow";
      }
      this.$post(url, params)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: this.followUpInfo.id ? "编辑成功" : "跟进成功",
              type: "success",
            });
            this.$emit("ok");
            // this.remarkInfo.remark = this.remark;
            // this.remarkClose();
          } else {
            this.$message(res.message);
          }
        })
        .finally(() => {
          this.remarkClose();
          this.loading = false;
        });
    },
  },
};
</script>

<style lang='scss' scoped>
#orderlist.complaint
  .complaint-img
  /deep/
  .ant-upload.ant-upload-select-picture-card:hover,
#orderlist.complaint
  .complaint-img
  /deep/
  .ant-upload.ant-upload-select-picture-card:hover {
  border-color: #3455d3;
}

#orderlist.complaint /deep/ .complaint-img > span {
  display: flex;
  flex-wrap: wrap;
}

#orderlist.complaint .complaint-img /deep/ .ant-upload-list {
  width: auto !important;
}

#orderlist.complaint
  .complaint-img
  /deep/
  .ant-upload.ant-upload-select-picture-card {
  margin-right: 0;
  border-radius: 2px;
}
#orderlist.remark_modal {
  &/deep/.el-dialog {
    width: 1000px !important;
  }

  &/deep/.el-dialog__body,
  &/deep/.el-dialog__footer {
    background: #eef0f3;
    margin: 0;
  }

  &/deep/.el-dialog__body {
    padding: 20px 24px !important;
  }

  &/deep/.el-dialog__header {
    height: 54px;
    padding: 19px 24px !important;
    background: #f9fafa;

    .el-dialog__title {
      font-size: 16px;
      line-height: 16px;
    }

    .el-dialog__headerbtn {
      top: 16px;
    }
  }

  .gengjiun {
    background: #fff;
    padding: 0 20px 20px;

    .modal-tit {
      height: 54px;
      padding: 20px 0 15px 0;
      font-size: 14px;
      line-height: 19px;
      color: #5e6066;
      font-weight: bold;
    }
  }
}

#orderlist /deep/.genjinupload {
  margin-top: 20px;

  .ant-upload.ant-upload-select-picture-card {
    width: 80px !important;
    height: 80px !important;
    margin-left: 0 !important;
  }

  .ant-upload-list {
    height: 80px !important;
  }

  .ant-upload-list-picture-card .ant-upload-list-item,
  .ant-upload-list-picture-card-container {
    width: 80px !important;
    height: 80px !important;
    padding: 0;
  }
}
</style>
